import React, { useState, useEffect } from 'react';
import { PDFDocument } from 'pdf-lib';
import fontkit from '@pdf-lib/fontkit'

let DrawDocuSign = (props) => {
  const [fileUrl, setFileUrl] = useState(null);
  // Funkcja do załadowania pliku PDF z folderu public
  const fetchPDF = async () => {
    const pdfUrl = '/grenke-docusign.pdf';  // Ścieżka do pliku w folderze public
    console.log(pdfUrl)
    try {
      const response = await fetch(pdfUrl);
      console.log(response)
      if (!response.ok) {
        throw new Error(`Błąd podczas pobierania pliku PDF: ${response.statusText}`);
      }
      const pdfBlob = await response.blob();
      console.log('PDF załadowany pomyślnie');
      return pdfBlob;
    } catch (error) {
      console.error('Błąd przy pobieraniu PDF:', error);
      throw new Error('Nie udało się pobrać pliku PDF');
    }
  };

  // Funkcja do edytowania PDF (dodanie tekstu i miejsca na podpis)
  const editPDF = async (pdfBlob) => {
  try {
    const existingPdfBytes = await pdfBlob.arrayBuffer();
    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    pdfDoc.registerFontkit(fontkit);
    const fontUrl = '/fonts/subset-Helvetica.ttf';
    const fontBytes = await fetch(fontUrl).then(res => res.arrayBuffer());
    const customFont = await pdfDoc.embedFont(fontBytes);
    const fontSize = 11;
    console.log('Dokument PDF załadowany pomyślnie');

    const page = pdfDoc.getPages()[0];

    // Funkcja dzieląca tekst na linie bez ucinania wyrazów
    function splitTextToLines(text, maxLength = 30) {
      const words = text.split(' ');
      let lines = [];
      let currentLine = '';

      for (const word of words) {
        if ((currentLine + word).length <= maxLength) {
          currentLine += (currentLine ? ' ' : '') + word;
        } else {
          if (currentLine) lines.push(currentLine);
          currentLine = word;
        }
      }

      if (currentLine) {
        lines.push(currentLine);
      }

      return lines;
    }

    // Funkcja rysująca wiele linii z kontrolą odstępów
    function drawMultilineText(page, lines, x, startY, fontSize, font, lineSpacing = 1) {
      let y = startY;
      for (const line of lines) {
        page.drawText(line, {
          x,
          y,
          size: fontSize,
          font
        });
        y -= fontSize + lineSpacing;
      }
    }

    // Rysowanie tekstu
    page.drawText(props.companyName, { x: 310, y: 680, size: fontSize, font: customFont });
    page.drawText(props.legalRepresentative, { x: 310, y: 650, size: fontSize, font: customFont });

    // ADRES wieloliniowo
    const addressLines = splitTextToLines(props.companyAddress, 30);
    drawMultilineText(page, addressLines, 310, 630, fontSize, customFont, 0); // <- odstęp 0

    page.drawText(props.phone, { x: 310, y: 600, size: fontSize, font: customFont });
    page.drawText(props.email, { x: 310, y: 580, size: fontSize, font: customFont });
    page.drawText(props.trn, { x: 310, y: 560, size: fontSize, font: customFont });

    page.drawText(props.shareCapital, { x: 310, y: 502, size: fontSize, font: customFont });
    page.drawText(props.legalForm, { x: 310, y: 483, size: fontSize, font: customFont });
    page.drawText(props.lineBusiness, { x: 310, y: 465, size: fontSize, font: customFont });
    page.drawText(props.revenueLastFinancialYear, { x: 310, y: 446, size: fontSize, font: customFont });
    page.drawText(props.revenuePresentFinancialYear, { x: 310, y: 426, size: fontSize, font: customFont });
    page.drawText(props.employeesNumber, { x: 310, y: 408, size: fontSize, font: customFont });
    page.drawText(props.financialAddress, { x: 310, y: 390, size: fontSize, font: customFont });

    page.drawText(props.bankName, { x: 310, y: 315, size: fontSize, font: customFont });
    page.drawText(props.bankIban, { x: 310, y: 293, size: fontSize, font: customFont });
    page.drawText(props.person.email, { x: 310, y: 273, size: fontSize, font: customFont });
    page.drawText(props.person.phone, { x: 310, y: 253, size: fontSize, font: customFont });

    console.log('Tekst dodany do dokumentu');

    const modifiedPdfBytes = await pdfDoc.save();
    console.log('PDF zapisany');

    const modifiedPdfBlob = new Blob([modifiedPdfBytes], { type: 'application/pdf' });
    console.log('Blob z zapisanym PDF utworzony');

    const file = new File([modifiedPdfBlob], 'modified-document.pdf', { type: 'application/pdf' });

    return file;
  } catch (error) {
    console.error('Błąd podczas edytowania PDF:', error);
    alert('Błąd przy edytowaniu PDF');
    throw error;
  }
};

  
  // Użycie tej funkcji w processDocument:
  const processDocument = async () => {
    try {
      const pdfBlob = await fetchPDF(); // Pobierz plik PDF
      const modifiedFile = await editPDF(pdfBlob); // Edytuj PDF, zwróci obiekt File
      console.log('Zmodyfikowany plik PDF', modifiedFile);
      
      // Przekaż zmodyfikowany plik do rodzica za pomocą props.setFile
      props.setFile(modifiedFile);
      
      // Utwórz URL do podglądu
      const fileUrl = URL.createObjectURL(modifiedFile);
      setFileUrl(fileUrl); // Ustaw URL do podglądu w iframe
    } catch (error) {
      console.error('Błąd przy edytowaniu PDF:', error);
      alert('Błąd przy edytowaniu PDF!');
    }
  };

  useEffect(() => {
    processDocument(); // Automatycznie przetwarzaj dokument po załadowaniu komponentu
  }, []);

  // Przekazanie fileUrl do props
  return ( 
    <div>
      {/* <h1>Edytor PDF z podpisem DocuSign</h1>

      {fileUrl && (
        <div>
          <h3>Podgląd zmodyfikowanego pliku PDF:</h3>
          Przekazujemy fileUrl jako props do innego komponentu
          <PreviewPDF fileUrl={fileUrl} />
        </div>
      )} */}
    </div>
  );
};

const PreviewPDF = ({ fileUrl }) => {
  return (
    <div>
      {/* <h3>Podgląd pliku PDF:</h3>
      <iframe src={fileUrl} width="600" height="400" title="Podgląd PDF"></iframe> */}
    </div>
  );
}

export default DrawDocuSign;
